export const AI_STATUS_REFRESH_EVENT = 'bp:ai-status-refresh'

export const requestAiStatusRefresh = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AI_STATUS_REFRESH_EVENT))
  }
}
